export default "__VITE_ASSET__Bint$TDq__"